module.exports = __webpack_public_path__ + "img/cmoffer.9ff36a51.png";